module.exports = __webpack_public_path__ + "img/cardY.a12862d5.png";